import { daysUntil } from "@/lib/format";

// Single source of truth for limitation-period status. Every surface (badge,
// clock, lists, timeline) must consume this rather than recomputing thresholds.
//   Safe        — more than 180 days remaining
//   Approaching — 31 to 180 days remaining
//   Critical    — 0 to 30 days remaining
//   Expired     — expiry date has passed
export const LIMITATION_WINDOW_DAYS = 1095; // 3-year reference window for the clock arc

export const LIMITATION_COLORS = {
  Safe: "#4F7A62",
  Approaching: "#9C6F2A",
  Critical: "#A85353",
  Expired: "#A85353",
};

// Returns null when no limitation date is set (callers should render nothing = "Not assessed").
// basis: "Verified" (rule-derived by the Track A engine) vs "Provisional" (manually entered /
// interim assumption). Until the Track A limitation engine exists, everything is Provisional —
// the UI must never present a manually-entered date as legally-determined limitation.
export function limitationStatus(limitationDate, { verified = false } = {}) {
  if (!limitationDate) return null;
  const daysLeft = daysUntil(limitationDate);
  if (daysLeft == null) return null;
  const band = daysLeft < 0 ? "Expired" : daysLeft <= 30 ? "Critical" : daysLeft <= 180 ? "Approaching" : "Safe";
  const label = band === "Expired" ? "Expired" : band === "Critical" ? `Critical · ${daysLeft}d` : `${daysLeft}d left`;
  const basis = verified ? "Verified" : "Provisional";
  return { daysLeft, band, color: LIMITATION_COLORS[band], label, basis, verified, isCritical: band === "Critical", isExpired: band === "Expired" };
}
